import { render } from "./student-introducer.vue?vue&type=template&id=a0ae8a36"
import script from "./student-introducer.vue?vue&type=script&lang=js"
export * from "./student-introducer.vue?vue&type=script&lang=js"

import exportComponent from "/builds/x3-web/pc/pc-yunxiao/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__